import { Button } from "@sfc/ui";

/**
 * Full-screen fallback for the iPhone shell's error boundary (SP-2628).
 * A native shell has no browser chrome, so without this button a crashed
 * WebView is a dead app until force-quit. Reloading also triggers the Swift
 * side's teardown-on-reload, so an orphaned native video overlay from the
 * crashed session is cleaned up too (SP-2320).
 */
export function IPhoneCrashScreen() {
  return (
    <div className="w-dvw h-dvh flex flex-col items-center justify-center gap-4 bg-background p-8 text-center">
      <div className="text-lg font-semibold">Something went wrong</div>
      <div className="text-sm text-muted-foreground">
        The error has been reported. Reload to pick up where you left off.
      </div>
      <Button onClick={() => window.location.reload()}>Reload</Button>
    </div>
  );
}
